module.exports = __webpack_public_path__ + "static/media/IMG_20191204_125443.ff13f4d7.jpg";